// Faq.js
import React from 'react';
import './PageContainer.css';


function Faq() {
  return (
    <div className="page-container">
      <h1>FAQ – CICJ IMMO</h1>
      <ul>
        <li><strong>Quels types de biens gérez-vous ?</strong> Appartements, villas, terrains, immeubles, biens commerciaux, projets BTP.</li>
        <li><strong>Prenez-vous une commission ?</strong> Oui, selon le type de mission (location, vente, gérance), toujours définie à l’avance avec le client.</li>
        <li><strong>Peut-on publier une annonce sur votre site ?</strong> Oui, les propriétaires peuvent soumettre leurs biens à publier. Validation après vérification.</li>
        <li><strong>Proposez-vous des services juridiques ?</strong> Oui. Conseil juridique, rédaction de contrats, régularisation foncière, titres foncier, bail, etc.</li>
        <li><strong>Est-ce possible de collaborer en tant qu’agence partenaire ?</strong> Oui, voir notre rubrique « Programmes partenaires ».</li>
        <li><strong>Faites-vous des analyses techniques ou des estimations ?</strong> Oui, avec notre équipe d’experts et d’ingénieurs certifiés.</li>
        <li><strong>Avez-vous des solutions pour la diaspora ?</strong> Oui. Suivi à distance, procuration, signature électronique, etc.</li>
      </ul>
    </div>
  );
}

export default Faq;